import type { EcuadorGeoFeature } from "../lab-v14/types/EcuadorGeoFeature";

export type GeoArRegionalStatus = "FIELD_BETA" | "EXPERIMENTAL" | "PLANNED";

export type GeoArRegionalSidecar = {
  mapPackId: string;
  geoPackId: string;
  status: GeoArRegionalStatus;
  bundledOffline: boolean;
  canonicalRegionId: string;
};

export const GEO_AR_NATIONAL_REGISTRY: readonly GeoArRegionalSidecar[] = [
  { mapPackId: "ecuador", geoPackId: "THERA-GEO-AR-ECUADOR-INDEX-V1", status: "EXPERIMENTAL", bundledOffline: true, canonicalRegionId: "ecuador" },
  { mapPackId: "azuay", geoPackId: "SIERRA-SUR-GEO-AR-FIELD-BETA-V1", status: "FIELD_BETA", bundledOffline: true, canonicalRegionId: "sierra-sur" },
  { mapPackId: "canar", geoPackId: "SIERRA-SUR-GEO-AR-FIELD-BETA-V1", status: "FIELD_BETA", bundledOffline: true, canonicalRegionId: "sierra-sur" },
  { mapPackId: "sierra-sur", geoPackId: "SIERRA-SUR-GEO-AR-FIELD-BETA-V1", status: "FIELD_BETA", bundledOffline: true, canonicalRegionId: "sierra-sur" },
  { mapPackId: "sierra-centro-oeste", geoPackId: "SIERRA-CENTRO-OESTE-GEO-AR-V1", status: "PLANNED", bundledOffline: false, canonicalRegionId: "sierra-centro-oeste" },
  { mapPackId: "sierra-centro-este", geoPackId: "SIERRA-CENTRO-ESTE-GEO-AR-V1", status: "PLANNED", bundledOffline: false, canonicalRegionId: "sierra-centro-este" },
  { mapPackId: "sierra-norte", geoPackId: "SIERRA-NORTE-GEO-AR-V1", status: "PLANNED", bundledOffline: false, canonicalRegionId: "sierra-norte" },
  { mapPackId: "costa-sur", geoPackId: "COSTA-SUR-GEO-AR-V1", status: "PLANNED", bundledOffline: false, canonicalRegionId: "costa-sur" },
  { mapPackId: "costa-centro", geoPackId: "COSTA-CENTRO-GEO-AR-V1", status: "PLANNED", bundledOffline: false, canonicalRegionId: "costa-centro" },
  { mapPackId: "costa-norte", geoPackId: "COSTA-NORTE-GEO-AR-V1", status: "PLANNED", bundledOffline: false, canonicalRegionId: "costa-norte" },
  { mapPackId: "amazonia-sur", geoPackId: "AMAZONIA-SUR-GEO-AR-V1", status: "PLANNED", bundledOffline: false, canonicalRegionId: "amazonia-sur" },
  { mapPackId: "amazonia-centro", geoPackId: "AMAZONIA-CENTRO-GEO-AR-V1", status: "PLANNED", bundledOffline: false, canonicalRegionId: "amazonia-centro" },
  { mapPackId: "amazonia-norte", geoPackId: "AMAZONIA-NORTE-GEO-AR-V1", status: "PLANNED", bundledOffline: false, canonicalRegionId: "amazonia-norte" },
  { mapPackId: "galapagos", geoPackId: "GALAPAGOS-GEO-AR-V1", status: "PLANNED", bundledOffline: false, canonicalRegionId: "galapagos" },
] as const;

export const SIERRA_SUR_FIELD_BETA_FEATURES: readonly EcuadorGeoFeature[] = [
  {
    feature_uuid: "sierra-sur-geonames-cerro-minas-seed",
    name: "Cerro Minas",
    normalized_name: "cerro minas",
    aliases: ["Minas"],
    feature_type: "SUMMIT",
    latitude: -3.075342,
    longitude: -79.365267,
    altitude: null,
    region: "SIERRA_SUR",
    province: "AZUAY",
    canton: null,
    protected_area: null,
    source: "GeoNames bootstrap bundled with THERA search",
    source_id: "seed-minas",
    license: "CC BY",
    provenance_type: "EXTERNAL",
    verified: false,
    verification_level: "REFERENCE",
    verification_date: null,
    offline_pack: "SIERRA-SUR-GEO-AR-FIELD-BETA-V1",
    updated_at: "2026-09-11T00:00:00Z",
    data_version: "1.0.0-field-beta",
  },
  {
    feature_uuid: "cajas-paraguillas-001",
    name: "Cerro Paraguillas",
    normalized_name: "cerro paraguillas",
    aliases: ["Paraguillas"],
    feature_type: "SUMMIT",
    latitude: -2.7601,
    longitude: -79.2464,
    altitude: 4419,
    region: "PARQUE_NACIONAL_CAJAS",
    province: "AZUAY",
    canton: null,
    protected_area: "PARQUE_NACIONAL_CAJAS",
    source: "MANUAL_REFERENCE",
    source_id: "CAJAS-PARAGUILLAS-001",
    license: "UNVERIFIED_REFERENCE_ONLY",
    provenance_type: "MANUAL_REFERENCE",
    verified: false,
    verification_level: "REFERENCE",
    verification_date: null,
    offline_pack: "SIERRA-SUR-GEO-AR-FIELD-BETA-V1",
    updated_at: "2026-09-11T00:00:00Z",
    data_version: "1.0.0-field-beta",
  },
] as const;

export const SIERRA_SUR_FIELD_BETA_METADATA = {
  catalog_id: "SIERRA-SUR-GEO-AR-FIELD-BETA-V1",
  catalog_version: "1.0.0-field-beta",
  region: "SIERRA_SUR",
  created_at: "2026-09-11T00:00:00Z",
  updated_at: "2026-09-11T00:00:00Z",
  source: "THERA field beta sidecar: GeoNames reference + THERA manual reference",
  feature_count: SIERRA_SUR_FIELD_BETA_FEATURES.length,
  checksum: "RUNTIME_NOT_A_RELEASE_CHECKSUM",
  offline_available: true,
} as const;
